<template>
    <CardBase class="shadow">
        <div class="px-2 py-2 border shadow flex justify-between cursor-pointer"
             @click="contentHidden = !contentHidden">
            <div>
                <slot name="title"></slot>
            </div>
            <div><ArrowDownSVG></ArrowDownSVG></div>
        </div>
        <transition name="fade">
            <div v-show="!contentHidden" class="ml-2 mt-2 mb-2">
                <slot name="content"></slot>
            </div>
        </transition>
    </CardBase>
</template>

<script>
    import CardBase from "@/components/shared/CardBase";
    import ArrowDownSVG from "@/components/shared/svgs/ArrowDownSVG";

    export default {
        name: "CollapsibleCardBase",
        components: { ArrowDownSVG, CardBase },
        data() {
            return {
                contentHidden: false
            }
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .25s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>